// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';

const api = new APICore();

const BASE_URL = config.SHIPMENTS_ANALYTICS_URL;

const makeApiCall = (endpoint: string, query: Query | string): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getShipmentsShippedWeights(query): any {
    const endpoint = '/shipped_weights';
    return makeApiCall(endpoint, query);
}

function getShipmentsBilledWeights(query): any {
    const endpoint = '/billed_weights';
    return makeApiCall(endpoint, query);
}

function getShipmentsCarrierWeights(query): any {
    const endpoint = '/weight_details';
    return makeApiCall(endpoint, query);
}

function getShipmentsAverageShippedWeight(query): any {
    const endpoint = '/average_shipped_weight';
    return makeApiCall(endpoint, query);
}

function getShipmentsAverageBilledWeight(query): any {
    const endpoint = '/average_billed_weight';
    return makeApiCall(endpoint, query);
}

export {
    getShipmentsShippedWeights,
    getShipmentsBilledWeights,
    getShipmentsCarrierWeights,
    getShipmentsAverageShippedWeight,
    getShipmentsAverageBilledWeight,
};
